import { findSiteFromUrl, findLocaleFromUrlAndCookie } from '@zooplus/commons-lang';
import { DEFAULT_LANG, ZOOPLUS_REALM } from './constants.js';

const ZOOPLUS_DE_SITE_ID = 1;
const CURRENT_SITE = findSiteFromUrl();
const CURRENT_SITE_DOMAIN = CURRENT_SITE?.domain || 'zooplus.de';
const CURRENT_SITE_ID = CURRENT_SITE?.id || ZOOPLUS_DE_SITE_ID;
const CURRENT_SITE_LANGUAGE = CURRENT_SITE?.language || DEFAULT_LANG;
const CURRENT_SITE_LOCALE = findLocaleFromUrlAndCookie();
const CURRENT_SITE_REALM = CURRENT_SITE?.realm || ZOOPLUS_REALM;

export { CURRENT_SITE_DOMAIN, CURRENT_SITE_ID, CURRENT_SITE_LANGUAGE, CURRENT_SITE_LOCALE, CURRENT_SITE_REALM };
//# sourceMappingURL=site-utils.js.map
